var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ComponentInput = (_a) => {
    var { type = 'text', hint = '', hintClasses = '', error, onChange = null, tabIndex = 0, innerRef = null, isDisabled = false, classes = '', wrapperClasses = '' } = _a, props = __rest(_a, ["type", "hint", "hintClasses", "error", "onChange", "tabIndex", "innerRef", "isDisabled", "classes", "wrapperClasses"]);
    return (_jsxs("div", Object.assign({ className: `form-input ${error ? 'form-input--error' : ''} ${wrapperClasses}` }, { children: [(typeof error === 'string' && error.length > 0) && (_jsx("span", Object.assign({ className: 'input-error text-viva-red text-sm' }, { children: error }))), _jsx("div", { children: _jsx("input", Object.assign({}, props, { type: type, ref: innerRef, className: `${classes} ${error ? 'error' : ''}`, onChange: (event) => onChange != null && onChange(event.target.value), tabIndex: tabIndex, disabled: isDisabled })) }), hint && _jsx("small", Object.assign({ className: `help-text ${hintClasses}` }, { children: hint }))] })));
};
ComponentInput.propTypes = {
    innerRef: PropTypes.oneOfType([PropTypes.shape]),
    type: PropTypes.string,
    hint: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    tabIndex: PropTypes.number,
    isDisabled: PropTypes.bool,
    classes: PropTypes.string,
    hintClasses: PropTypes.string
};
export default ComponentInput;
